import { createSlice } from "@reduxjs/toolkit";
import { parseJSON } from "helpers/storage-helpers";
const user = localStorage.getItem("user") || "{}";

const initialState = {
  id: null,
  username: null,
  email: null,
  firstName: null,
  lastName: null,
  confirmed: false,
  blocked: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState: user ? parseJSON(user) || initialState : initialState,
  reducers: {
    setUser: (state, action) => {
      const user = action.payload;
      return user;
    },
    logout: (state, action) => {
      return initialState;
    },
  },
});

export const { setUser, logout } = userSlice.actions;

export default userSlice.reducer;
